/*
 * @Author: 魑魅魍魉鬼魃魈
 * @Date: 2021-10-22 15:32:46
 * @LastEditTime: 2021-12-03 12:05:15
 * @Description: 描述
 */
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme/index.css'  // elementUI 的自定义样式CSS
import { Pagination, Button, Input, Dialog, Image, Loading, Icon, Select, Option, Carousel,CarouselItem,Form, FormItem,  Popover,Row,Col} from 'element-ui'
Vue.use(Button)
Vue.component(Button.name, Button)
Vue.component(Input.name, Input)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Dialog.name, Dialog)
// Vue.component(Message.name, Message);
Vue.component(Image.name, Image)
Vue.component(Icon.name, Icon)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Popover.name, Popover)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)

// Vue.component(Loading.name, Loading);
Vue.use(Loading.directive)
Vue.component(Pagination.name, Pagination)

import App from './App.vue'
import router from './router'
import store from './store'
import * as api from './service/api'
import * as utils from './utils'

import 'font-awesome/css/font-awesome.min.css'
import './styles/animate.min.css'
import './styles/global.less'
import { message } from './utils/message'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

utils.initSensors()

Vue.prototype.$api = api
Vue.prototype.$utils = utils
Vue.prototype.$toast = utils.toast
Vue.prototype.$message = message
Vue.prototype.$loading = Loading.service

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
